import { createSlice } from "@reduxjs/toolkit";
import { changePasswordBuilder } from "./builder";

const initialState = {
  loading: false,
  error: null,
  message: null,
};

export const passwordChangeSlice = createSlice({
  name: "passwordChange",
  initialState,
  reducers: {
    clearPasswordChangeState: (state) => {
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    changePasswordBuilder(builder);
  },
});

export const { clearPasswordChangeState } = passwordChangeSlice.actions;

export const selectPasswordChangeLoading = (state) =>
  state.passwordChange.loading;
export const selectPasswordChangeError = (state) => state.passwordChange.error;
export const selectPasswordChangeMessage = (state) =>
  state.passwordChange.message;

export default passwordChangeSlice.reducer;
